import { IonIcon, IonItem, IonList } from '@ionic/react';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getConfig } from '../../appConfig';
import { NormalText, SmallText, StrongText, Subtitle, Title } from '../../components/common';
import Basket from '../../lib/basket';
import { withTranslation } from '../../lib/translate';
import { forwardTo } from '../../lib/utils';
import './index.css';
import { chevronForward } from 'ionicons/icons';

class TileOrderList extends Component {
	constructor(props) {
		super(props);
		this.ionList = null;
		this.orderListItems = null;
	}
	componentDidMount() {
		const item = document.querySelector('.order-list-items');
		const itemList = document.querySelector('.order-list-items > ion-list');
		if (item && itemList) {
			this.ionList = itemList;
		}
	}

	itemList = (__, item, index) => {
		const { profile } = this.props;
		const selectedResturant = Basket.getRestaurant();
		let itemIsDisabled = false;
		if (selectedResturant && selectedResturant.disabled_skus && selectedResturant.disabled_skus.length > 0) {
			itemIsDisabled = selectedResturant.disabled_skus.includes(item.sku);
		}
		if (item.sku === undefined || itemIsDisabled) {
			return <></>;
		}
		if (item !== null) {
			let image = item.itemRichData && item.itemRichData.squareImageUrl ? item.itemRichData.squareImageUrl : '';
			if (image && image.indexOf('http://') !== -1) {
				image = image.replace(/http:\/\//g, 'https://');
			}
			item.selectedMenu = this.props.selectedMenu;
			item.menuFilters = this.props.menuFilters;
			return (
				<IonItem
					className={`box-content ${!Basket.isProductUnsnoozed(item) ? 'disabled-element' : ''} `}
					key={index}
					lines="none"
					onClick={() => (Basket.isProductUnsnoozed(item) ? forwardTo('/item-details', item) : null)}
				>
					<div tabIndex="-1" className="order-list-item">
						<div className="item-price">
							<NormalText className='bold label-color'>{Basket.formatPrice(Basket.getProductCardPrice(item), true)}</NormalText>
							{item.originalPrice ? (
								<>
									<br />
									<NormalText className='bold label-color' >&#163;{item.originalPrice}</NormalText>
								</>
							) : null}
						</div>
						<div className="item-content">
							<StrongText >{__(Basket.getProductName(item, profile))}</StrongText>
							<div
								className='item-content-description'

								dangerouslySetInnerHTML={{
									__html: Basket.getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, ''),
								}}
							/>
							{item.curated_restaurant_name && (
								<div className="curated-restaurant-name">
									<SmallText>{item.curated_restaurant_name}</SmallText>
								</div>
							)}
						</div>
						{!getConfig().flags.removeMenuImages &&
							<div className="item-image-wrapper">
								<div
									className="item-image"
									style={
										image && image !== ''
											? { backgroundImage: `url(${image})` }
											: { backgroundSize: 'contain', backgroundImage: `url(${Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image})` }
									}
								/>
							</div>
						}

					</div>
				</IonItem>
			);
		}
	};
	setBackgroundImage = (category) => {
		if (category) {
			if (category?.type === 'group' && category?.itemRichData && category?.itemRichData?.rawImageUrl) {
				let image = category.itemRichData.rawImageUrl;
				if (image && image.indexOf('http://') !== -1) {
					image = image.replace(/http:\/\//g, 'https://');
				}
				return { backgroundImage: `url(${image})` };
			}
			if (!category.menuEntry) {
				let image = category.itemRichData?.rawImageUrl;
				if (image && image.indexOf('http://') !== -1) {
					image = image.replace(/http:\/\//g, 'https://');
				}
				return { backgroundImage: `url(${image})` };
			}
			const item = category.menuEntry.find((el) => el.itemRichData && el.itemRichData.rawImageUrl);
			if (item) {
				let image = item.itemRichData.rawImageUrl;
				if (image && image.indexOf('http://') !== -1) {
					image = image.replace(/http:\/\//g, 'https://');
				}
				return { backgroundImage: `url(${image})` };
			}
			return this.setBackgroundImage(category.menuEntry[0]);
		}
	};
	scrolToCategory = (category, index) => {
		if (this.props.onScrollToCategory) {
			this.props.onScrollToCategory(category, index);
		}
	}
	drawTiles(__, data) {
		const categories = data.menuEntry || data.menuEntryGroups || [];
		return categories.map((el, index) => {
			if (el['@type'] === 'group') {
				return (
					<div
						onClick={() => {
							if (getConfig().flags.hasContinuosScrollMenu) {
								this.scrolToCategory(el, index)

							} else {
								this.props.selectMenu(index);
								this.ionList.parentElement.parentElement.scrollIntoView();
							}
						}}
						className={(getConfig().menuDisplayType === 3 && !getConfig().flags.hasMenuTileButtons) ? 'order-categories-two-columns-tiles-wrapper' : 'order-categories-tiles-wrapper'} key={index} >
						{getConfig().flags.hasMenuTileButtons ? <div className='order-categories-tile-button box-content'>
							<div

								className='order-categories-tile-button-image' style={this.setBackgroundImage(el)}>
							</div>
							<Subtitle >{Basket.getCategoryName(el, this.props.profile)}</Subtitle>
							<IonIcon icon={chevronForward} />
						</div> :

							<div
								className="order-categories-tile box-content"
								style={this.setBackgroundImage(el)}

							>
								<span className="order-categories-tile-title">{Basket.getCategoryName(el, this.props.profile)}</span>
							</div>
						}
					</div >
				);
			} else {
				return this.itemList(__, el, index);
			}
		});
	}

	render() {
		const { __, category } = this.props;
		return (
			<div className="order-list-items " id="order-list-items">
				<Title className="category-title page-title-centered">{Basket.getCategoryName(category, this.props.profile) || null}</Title>
				<IonList className='order-list-items-tiles' lines="none">{this.drawTiles(__, category)}</IonList>
			</div>
		);
	}
}

const mapStateToProps = (store) => {
	return {
		profile: store.profile.profile,
		restaurantsUpdated: store.restaurants.restaurantsUpdated,
		basketUpdated: store.orders.basketUpdated,
		clientProfile: store.common.clientProfile,
	};
};

export default connect(mapStateToProps)(withTranslation(TileOrderList));
